import React, { useEffect } from 'react'

import { useWrapperContext } from 'components/Wrapper/Wrapper'
import { NavLink } from 'react-router-dom'
import { BackButton } from 'shared/components'
import { FAQ } from './FAQ/FAQ'
import { FormWrapper } from './FormWrapper/FormWrapper'
import { Info } from './Info/Info'

import classes from './ComplianceMemo.module.scss'

export const ComplianceMemo: React.FC = () => {
  const { setHeaderWhite } = useWrapperContext()

  useEffect(() => {
    setHeaderWhite(true)
    return () => setHeaderWhite(false)
  })

  return (
    <div className="offset-header">
      <div className={`container container-full ${classes.container_full}`}>
        <NavLink to="/compliance">
          <BackButton text="Назад" />
        </NavLink>
      </div>

      <div className="container">
        <Info />
        <FAQ />
        <FormWrapper />
      </div>
    </div>
  )
}
